module.exports = __webpack_public_path__ + "img/errorImagen.ad4f4044.png";